import React from "react";
import PropTypes from "prop-types";
import BaseBlock from "./BaseBlock";
import useBlockData from "./useBlockData";
import { signedPct } from "./format";

/**
 * MoMChangeBlock - month-over-month spend change vs. the previous period.
 *
 * GET /api/v1/financial-control/summary -> { summary: { kpis: { spend_vs_forecast: {
 *   mom_pct, prev_month_label } } } } (financialcontrol.SpendVsForecastKPI).
 */
const MoMChangeBlock = ({ title = "Month-over-month", period }) => {
  const { data, isLoading, error } = useBlockData("/api/v1/financial-control/summary", {
    params: period ? { period } : undefined,
  });

  const kpi = data?.summary?.kpis?.spend_vs_forecast;
  const momPct = kpi?.mom_pct;
  const prevLabel = kpi?.prev_month_label;

  return (
    <BaseBlock title={title} isLoading={isLoading} error={error}>
      <p className="a4-mom-value">{signedPct(momPct)}</p>
      <p className="a4-mom-caption">vs. {prevLabel || "prior month"}</p>
    </BaseBlock>
  );
};

MoMChangeBlock.propTypes = {
  title: PropTypes.string,
  period: PropTypes.string,
};

export default MoMChangeBlock;
